// Ledger entry types, as stored by the server (see server/helpers/eventTypes.js)
export const eventTypes = {
  payment: 'Payment',
  charge: 'Charge',
  credit: 'Credit',
  note: 'Note'
}
